import { FC, useEffect } from "react";
import { AxiosResponse } from "axios";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { postAuthenticationAPI } from "../../../../../../datasources/api";
import { Skeleton } from "@mui/material";

interface Props {
    dashboardId: string;
}

interface SupersetGuestTokenResponse {
    token: string;
}

const SupersetDashboard: FC<Props> = ({dashboardId}) => {

    const getToken = async () => {
        const response = await postAuthenticationAPI.get<null, AxiosResponse<SupersetGuestTokenResponse>>(
            `/auth/sign-in/superset`,
            {
                params: {dashboardId}
            }
        );
        return response.data.token;
    }

    useEffect(() => {
        // Ensure the iframe created by embedDashboard fills the container.
        // We add a CSS rule that sets inline styles on any added iframe. 
        // The CSS uses !important to override any sizing the embed code might add.
        const styleId = "results-dashboard-iframe-style";
        if (!document.getElementById(styleId)) {
            const style = document.createElement("style");
            style.id = styleId;
            style.innerHTML = `
                #dashboard > iframe {
                    width: 100% !important;
                    height: 100% !important;
                    border: 0 !important;
                    display: block;
                }
            `;
            document.head.appendChild(style);
        }

        const mountPoint = document.getElementById("dashboard");

        const supersetDomain = import.meta.env.VITE_SUPERSET_URL;

        const embed = async () => {
            const mp = document.getElementById("dashboard");
            mp && supersetDomain && await embedDashboard({
                id: dashboardId, // given by the Superset embedding UI
                supersetDomain,
                mountPoint: mp, // html element in which iframe render
                fetchGuestToken: () => getToken(),
                dashboardUiConfig: {
                    // urlParams: {
                    //     lang: 'it',
                    //     username: 'MyGrUsername',
                    // },
                    // hideTitle: true,
                    // hideChartControls: true,
                    // hideTab: true,
                },
                iframeSandboxExtras: ['allow-same-origin', 'allow-top-navigation', 'allow-popups-to-escape-sandbox', 'allow-downloads', "allow-scripts", "allow-presentation", "allow-downloads", "allow-forms", "allow-popups" ]
            });

        };

        if (mountPoint) {
            embed();
        }

    }, []);

    if (dashboardId === "") {
        return <></>;
    }

    return (
        <div id="dashboard" style={{width: "100%", minHeight: "450px", height: "75vh"}}>
            <Skeleton variant="rounded" width='100%' height='75vh' />
        </div>
    );

}

export default SupersetDashboard;